import { Pipe, PipeTransform } from '@angular/core';
import { EnvironmentService } from '@methylium/core';

import { Device } from '@era/locations-sdk';

@Pipe({ name: 'mdmLink' })
export class MdmLinkPipe implements PipeTransform {
  constructor(private enviromentService: EnvironmentService) {}

  transform(value: Device): string {
    if (!this.enviromentService.environment?.mdm?.deviceUrl) {
      throw new Error('The MDM Device Url is not set in the environment configuration.');
    }

    if (!value?.deviceId) {
      return;
    }

    // TODO Support other device types
    return `${this.enviromentService.environment.mdm.deviceUrl as string}/apple/${value.deviceId}`;
  }
}
